export default "__VITE_ASSET__bf8a1251__"